// Opens the production web app in the system browser (Electron forwards
// window.open(https://…) to shell.openExternal). Used by the custom desktop
// account UI to delegate advanced management (profile, members, roles) to the
// web, where Clerk's prebuilt components work.
export async function openWebExternal(path = ''): Promise<void> {
  try {
    const base = (await window.electronAPI?.sync.getVpsUrl()) ?? '';
    if (base) window.open(base.replace(/\/$/, '') + path, '_blank');
  } catch {
    // non-critical
  }
}
